import React, { useState, useEffect } from "react";
import { Input, FormGroup, Label, Button } from "reactstrap";
import { useNavigate } from "react-router-dom";
import axios from "axios";
import { getAllBlogCategory } from "../../redux/actions/indexActions";
import { useSelector, useDispatch } from "react-redux";
import { toast } from "react-toastify";
import CKEditor from "react-ckeditor-component";

const AddCheckThisOut = () => {
    const [formData, setFormData] = useState({
        name: "",
        video_url: "",
        location: "",
        type: "",
        thumbnail: "",
        state_id: "",
    });
    const [errors, setErrors] = useState({});
    const [text, setText] = useState([]);
    const [blogCategories, setBlogCategories] = useState([]);
    const [stateLists, setStateLists] = useState([]);
    const {
        AuthReducer: { auth }
    } = useSelector((state) => state);
    const navigate = useNavigate();
    const dispatch = useDispatch();

    useEffect(() => {
        dispatch(getAllBlogCategory(auth.token));
    }, [auth]);

    const handleText = (e) => {
        const descriptions = e.editor.getData();
        setText(descriptions);
    }

    useEffect(() => {
        axios(`/api/admin/v1/all-blog-category/?type=2`, {
            headers: {
                Authorization: `Bearer ${auth.token}`,
            },
        })
            .then(({ data }) => {
                setBlogCategories(data?.BlogCategories);
            })
            .catch((err) => console.error(err));

        axios(`/api/admin/v1/state-list`, {
            headers: {
                Authorization: `Bearer ${auth.token}`,
            },
        })
            .then(({ data }) => {
                setStateLists(data?.stateLists);
            })
            .catch((err) => console.error(err));
    }, []);

    const inputHandler = (e) => {
        const { name, value } = e.target;
        if (name === "thumbnail") {
            setFormData({ ...formData, [name]: e.target.files[0] });
        } else {
            setFormData({ ...formData, [name]: value });
        }

    };
    const handleSubmit = () => {
        const form = new FormData();
        form.append('category_id', formData.category_id);
        form.append('name', formData.name);
        form.append('video_url', formData.video_url);
        form.append('location', formData.location);
        form.append('type', formData.type);
        form.append('thumbnail', formData.thumbnail);
        form.append('state_id', formData.state_id);
        axios
            .post(`/api/admin/v1/add-check-this-out`, form, {
                headers: {
                    Authorization: `Bearer ${auth?.token}`,
                },
            })
            .then((res) => {
                toast.success(res.data?.message);
                navigate(-1);
            })
            .catch((err) => {
                toast.error(err.response.data);
                setErrors(err.response.data);
            });
    };


    return (
        <div>
            <div className="row my-3">
                <div className="col-md-12">
                    <h4 className="text-white">Add Media</h4>
                </div>
            </div>
            <div className="bg-white px-3 py-4 rounded-2  my-4">
                <div className="row">
                    <div className="col-md-4 offset-md-1">
                        <FormGroup>
                            <Label> Name <span className="text-danger fs-4">*</span></Label>
                            <Input
                                invalid={Boolean(errors?.name)}
                                value={formData?.name}
                                name="name"
                                onChange={inputHandler}
                            />
                            <span className="d-block text-danger"> {errors?.name} </span>
                        </FormGroup>
                    </div>
                    <div className="col-md-4 offset-md-1">
                        <FormGroup>
                            <Label>Location <span className="text-danger fs-4">*</span></Label>
                            <Input
                                invalid={Boolean(errors?.location)}
                                value={formData?.location}
                                name="location"
                                onChange={inputHandler}
                            />
                            <span className="d-block text-danger"> {errors?.location} </span>
                        </FormGroup>
                    </div>
                    <div className="col-md-4 offset-md-1">
                        <FormGroup>
                            <Label>Type <span className="text-danger fs-4">*</span></Label>
                            <Input
                                value={formData?.sub_category_id}
                                type="select"
                                name="type"
                                onChange={inputHandler}
                            >
                                <option value="">Select Type</option>
                                <option key='' value='image'>Image</option>
                                <option key='' value='video'>Video</option>

                            </Input>
                            <span className="d-block text-danger">{errors?.sub_category_id}</span>
                        </FormGroup>
                    </div>
                    <div className="col-md-4 offset-md-1">
                        <FormGroup>
                            <Label>Upload Thumbnail</Label>
                            <Input type="file" name="thumbnail" onChange={(e) => setFormData(prev => ({ ...prev, thumbnail: e.target.files[0] }))} />
                            <span className="d-block text-danger">{errors?.thumbnail}</span>
                        </FormGroup>
                    </div>


                    <div className="col-md-4 offset-md-1">
                        <FormGroup>
                            <Label>Video Url</Label>
                            <Input
                                invalid={Boolean(errors?.video_url)}
                                value={formData?.video_url}
                                name="video_url"
                                onChange={inputHandler}
                            />
                            <span className="d-block text-danger"> {errors?.video_url} </span>
                        </FormGroup>
                    </div>

                    <div className="col-md-4 offset-md-1">
                        <FormGroup>
                            <Label>State </Label>
                        <Input
                            value={formData?.state_id || ''}
                            type="select"
                            name="state_id"
                            onChange={inputHandler}
                            >
                            <option value="">Select Type</option>
                            {stateLists?.map((state) => (
                                <option key={state.id} value={state.id}>
                                {state.state_name}
                                </option>
                            ))}
                            </Input>

                            <span className="d-block text-danger">{errors?.state_id}</span>
                        </FormGroup>
                    </div>

                    <div className="col-md-4 offset-md-4">
                        <Button color="primary" onClick={handleSubmit}>
                            Submit
                        </Button>
                        <Button className="ms-3" onClick={() => navigate(-1)}>
                            Cancel
                        </Button>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default AddCheckThisOut;
